import {Cart} from 'apps/Cart'
import {CartItemBuilder} from 'apps/CartItemBuilder/'
import {CartPreview} from 'apps/CartPreview'
import {Checkout} from 'apps/Checkout'
import {Confirming} from 'apps/Confirming/Confirming'
import {Order} from 'apps/Order'
import {ErrorBoundary} from 'components/system/ErrorBoundary'
import {RootProvider} from 'providers/RootProvider'
import React, {ReactNode} from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'

declare global {
  interface Window {
    showCartItemBuilder: (
      containerId: string,
      productId: string,
      optionId?: string,
      stepOrder?: 'guestsFirst' | 'optionFirst'
    ) => void
    showCart: (containerId: string) => void
    showCheckout: (containerId: string) => void
    showCartPreview: (containerId: string) => void
    showConfirming: (containerId: string) => void
    showOrder: (containerId: string) => void
  }
}

const startApp = (containerId: string, app: ReactNode) => {
  const containerElement = document.getElementById(containerId)

  if (!containerElement) {
    throw new Error(`Can't find container element`)
  }

  const rootElement = document.createElement('div')
  rootElement.classList.add('dcw')
  containerElement.appendChild(rootElement)

  const root = ReactDOM.createRoot(rootElement)

  root.render(
    <React.StrictMode>
      <RootProvider root={root} rootElement={rootElement}>
        <ErrorBoundary>{app}</ErrorBoundary>
      </RootProvider>
    </React.StrictMode>
  )
}

window.showCartItemBuilder = (
  containerId: string,
  productId: string,
  optionId?: string,
  stepOrder?: 'guestsFirst' | 'optionFirst'
) => {
  startApp(containerId, <CartItemBuilder productId={productId} optionId={optionId} stepOrder={stepOrder} />)
}

window.showCart = (containerId: string) => {
  startApp(containerId, <Cart />)
}

window.showCheckout = (containerId: string) => {
  startApp(containerId, <Checkout />)
}

window.showCartPreview = (containerId: string) => {
  startApp(containerId, <CartPreview />)
}

window.showConfirming = (containerId: string) => {
  startApp(
    containerId,
    <Confirming paymentIntentId={new URLSearchParams(window.location.search).get('payment_intent') || ''} />
  )
}

window.showOrder = (containerId: string) => {
  startApp(containerId, <Order />)
}
